import _regeneratorRuntime from 'babel-runtime/regenerator';

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(fetchManifest),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(saga);

import { put, all, takeEvery } from 'redux-saga/effects';
import { ROUTING_SELECT_MANIFEST } from './routing';
import { manifest } from '../schema/presentation2';
import { iiifResourceRequest } from './iiif-resource';

var MANIFEST_REQUEST = 'MANIFEST_REQUEST';
var MANIFEST_SUCCESS = 'MANIFEST_SUCCESS';
var MANIFEST_ERROR = 'MANIFEST_ERROR';

function fetchManifest(_ref) {
  var id = _ref.payload.id;
  return _regeneratorRuntime.wrap(function fetchManifest$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return put(iiifResourceRequest(id, [MANIFEST_REQUEST, MANIFEST_SUCCESS, MANIFEST_ERROR], manifest));

        case 2:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function saga() {
  return _regeneratorRuntime.wrap(function saga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return all([takeEvery(ROUTING_SELECT_MANIFEST, fetchManifest)]);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

export { MANIFEST_SUCCESS, MANIFEST_REQUEST, MANIFEST_ERROR, saga };